import React from 'react';
import { Tag } from 'antd';
import styled from '@emotion/styled';
import { HomeType, HomeTypeExplorer } from '../../../../types/home';
import { convertTemplateHomeTiles } from '../../../../utils/transfer/home';
import { appStyles } from '../../../../styles';

interface TemplateColumnProps {
  type: HomeType | HomeTypeExplorer;
}

export default React.memo((props: TemplateColumnProps) => {
  return (
    <StyledContainer>
      <Tag color="#EEEEEE" className="default">
        {convertTemplateHomeTiles(props.type)}
      </Tag>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  .ant-tag {
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    border-radius: 0;
    font-size: 14px;
    &.default {
      ${appStyles.color.black}
    }
  }
`;
